import { useRecordContext, useTranslate } from 'react-admin';
import { Typography, Box } from '@mui/material';

const MultilineTextField = ({ source, label, sx, emptyText = '' }) => {
  const record = useRecordContext();
  const translate = useTranslate();
  const text = record?.[source];

  return (
    <Box sx={sx}>
      {label && (
        <Typography variant="body2" color="textSecondary" gutterBottom>
          {translate(label)}
        </Typography>
      )}
      <Typography
        component="div"
        style={{ whiteSpace: 'pre-wrap', fontFamily: 'monospace', fontSize: 12 }}
      >
        {text?.trim() ? text : translate(emptyText)}
      </Typography>
    </Box>
  );
};

export default MultilineTextField;
